import * as React from 'react';

import { connect } from 'react-redux';
import { ApplicationState } from 'src/store';
import { alertError } from 'src/store/alert/actions';
import { createEvent } from 'src/store/events/actions';
import { CreateEventData } from 'src/store/events/types';
import { getUsers } from 'src/store/user/action';
import CreateEventForm, { FormValues } from './CreateEventForm';
import { User } from 'src/store/user/types';
import { RouteComponentProps } from 'react-router';

const initialValues: FormValues = {
  title: '',
  bikesAllowed: false,
  description: '',
  dateranges: [
    {
      start: undefined,
      end: undefined
    }
  ],
  quota: '',
  shortDescription: '',
  weekDays: [],
  startTime: null,
  familyFriendly: false,
  age: '',
  price: '',
  difficulty: -1,
  buses: [],
  stations: [],
  picture: undefined,
  guides: [],
  eventType: 0,
  meetingpoint: '',
  duration: ''
};

interface Props {
  createEvent: typeof createEvent;
  alertError: typeof alertError;
  loading: boolean;
  getUsers: any;
  guides: User[];
  imageLoading: boolean;
}

type Allprops = Props & RouteComponentProps;

class CreateEvent extends React.Component<Allprops> {
  render() {
    return (
      <CreateEventForm
        loadingImage={this.props.imageLoading}
        {...this.props}
        editMode={false}
        initialValues={initialValues}
      />
    );
  }
}

const mapStateToProps = ({ events, users, image }: ApplicationState) => ({
  loading: events.loading,
  guides: users.users,
  imageLoading: image.loading
});

const mapDispatchToProps = (dispatch: any) => ({
  createEvent: (event: CreateEventData, file?: File, succesCB?: () => any) =>
    dispatch(createEvent(event, file, succesCB)),
  alertError: (err: Error) => dispatch(alertError(err)),
  getUsers: () => dispatch(getUsers('/type/Guide', undefined))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEvent);



// WEBPACK FOOTER //
// ./src/components/Event/EventManagement/CreateEvent.tsx